import { useCallback, useRef } from 'react';

import {
    useValidatePin,
    useValidateMFA,
    useValidate2FA,
    useValidateTCVersion,
    useValidateFitToPlay,
    useValidatePasswordChange
} from './hooks';

export const useValidateSession = () => {
    const validationsRef = useRef(new Set());
    const validateTCVersion = useValidateTCVersion(validationsRef);
    const validatePasswordChange = useValidatePasswordChange(validationsRef);
    const validate2FA = useValidate2FA(validationsRef);
    const validateMFA = useValidateMFA(validationsRef);
    const validatePin = useValidatePin(validationsRef);
    const validateFitToPlay = useValidateFitToPlay(validationsRef);

    return useCallback((pasLoginResponse, credentials, options) => {
        const { sessionValidationData } = pasLoginResponse?.data || {};

        validationsRef.current.clear();

        if (!sessionValidationData) {
            return true;
        }

        validateTCVersion(pasLoginResponse, credentials, options);
        validatePasswordChange(pasLoginResponse, credentials, options);
        validateMFA(pasLoginResponse, credentials, options);
        validate2FA(pasLoginResponse, credentials, options);
        validatePin(pasLoginResponse, credentials, options);
        validateFitToPlay(pasLoginResponse, credentials, options);

        return !validationsRef.current.size;
    }, [validationsRef, validateTCVersion, validatePasswordChange, validate2FA, validateMFA, validatePin, validateFitToPlay]);
};
